var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextRoadmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 1482 655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(683.425 3160.7) scale(88.4358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(720.303 3160.7) scale(88.4358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(758.242 3160.7) scale(88.4358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.209-.7H.057V0h.152c.114 0 .176-.062.176-.177v-.346C.385-.638.323-.7.209-.7zm-.004.098c.051 0 .074.027.074.086v.332c0 .059-.023.086-.074.086H.163v-.504h.042z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(794.943 3160.7) scale(88.4358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(849.861 3160.7) scale(88.4358)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(899.651 3160.7) scale(88.4358)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(936.352 3160.7) scale(88.4358)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(681.391 3160.7) scale(88.4358)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(718.269 3160.7) scale(88.4358)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(756.208 3160.7) scale(88.4358)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.209-.7H.057V0h.152c.114 0 .176-.062.176-.177v-.346C.385-.638.323-.7.209-.7zm-.004.098c.051 0 .074.027.074.086v.332c0 .059-.023.086-.074.086H.163v-.504h.042z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(792.909 3160.7) scale(88.4358)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(847.827 3160.7) scale(88.4358)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(897.617 3160.7) scale(88.4358)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(934.318 3160.7) scale(88.4358)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(682.364 3160.7) scale(88.4358)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(719.242 3160.7) scale(88.4358)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(757.181 3160.7) scale(88.4358)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.209-.7H.057V0h.152c.114 0 .176-.062.176-.177v-.346C.385-.638.323-.7.209-.7zm-.004.098c.051 0 .074.027.074.086v.332c0 .059-.023.086-.074.086H.163v-.504h.042z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(793.882 3160.7) scale(88.4358)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(848.8 3160.7) scale(88.4358)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(898.59 3160.7) scale(88.4358)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2722.38 -12720.2) scale(4.16667) translate(935.29 3160.7) scale(88.4358)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M470.154 267.308H500.725V323.354H470.154z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M769.433 477.7H796.587V504.858H769.433z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M0 172.712H33.121V205.833H0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1390.26 298.438H1410.452V308.63H1390.26z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1271.19 0H1326.977V30.571H1271.19z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M475.413 618.921H607.892V654.484H475.413z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1410.45 298.438H1481.7830000000001V308.63H1410.45z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1213.95 470.642H1270V511.405H1213.95z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1326.98 0H1342.267V30.571H1326.98z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M110.229 489.833H186.65800000000002V540.787H110.229z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M889.787 77.287H950.933V101.02000000000001H889.787z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M222.804 12.867H345.092V38.342H222.804z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M607.892 618.921H658.846V654.484H607.892z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextRoadmap);
export default __webpack_public_path__ + "static/media/text-roadmap.922dbe4bd434d51ee7a5aed68706a217.svg";
export { ForwardRef as ReactComponent };